<template>
	<div class="page">
		<div>
			<div class="logo">
				<img src="@/assets/images/home_logo.png" />
			</div>
			<div class="tab">
				<div class="inter">
					<div class="item" v-for="(item, index) in tab" :key="index" :class="`item_${item.key}`" @click.stop="goNext(item, index)">
						<div class="flex">
							<div class="icon_box">
								<img :src="item.icon" />
							</div>
							<div>
								<div class="name">{{ item.name }}</div>
								<div class="emglish">{{ item.english }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '../config/config';

export default {
	components: {},
	data() {
		return {
			tab: [
				{
					icon: require('../assets/home_icon/news.png'),
					name: '企业动态',
					english: 'News',
					key: 'news',
					path: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=Mzg2OTYwODIzMA==&action=getalbum&album_id=2881638234777501700#wechat_redirect',
					is_web: true
				},
				{
					icon: require('../assets/home_icon/resource.png'),
					name: '资料中心',
					english: 'Resource',
					key: 'resource',
					path: 'https://clould-app.lookstar.com.cn/data-download?tenant=21df85d2-5b9f-4188-be4e-0a4a1afdbce1&project=1840&appid=wx7c7f3e28dd203c39&utm_campaign=%E6%B5%8B%E8%AF%95&utm_source=%E9%A2%86%E8%8B%B1',
					is_web: true
				},
				{
					icon: require('../assets/home_icon/solution.png'),
					name: '解决方案',
					english: 'Solution',
					key: 'solution',
					path: '/solution',
					is_web: false
				},
				{
					icon: require('../assets/home_icon/product.png'),
					name: '产品中心',
					english: 'Product',
					key: 'product',
					path: '/product',
					is_web: false
				},
				{
					icon: require('../assets/home_icon/service.png'),
					name: '售后服务',
					english: 'Service',
					key: 'service',
					path: '/service',
					is_web: false
				},
				{
					icon: require('../assets/home_icon/video.png'),
					name: '视频中心',
					english: 'Video',
					key: 'video-index',
					path: '/video-index',
					is_web: false
				},
				{
					icon: require('../assets/home_icon/webinar.png'),
					name: '微学院',
					english: 'Webinar',
					key: 'webinar',
					path: 'https://appjuj8r4ji9112.h5.xiaoeknow.com/p/decorate/homepage?share_user_id=anonymous_o7RKmdcVt1YpkNSQe&wework_share_customer_id=anonymous_o7RKmdcVt1YpkNSQe&entry=2&entry_type=2002',
					is_web: true
				},
				{
					icon: require('../assets/home_icon/about_us.png'),
					name: '关于我们',
					english: 'About Us',
					key: 'about_us',
					path: '/about',
					is_web: false
				},
				{
					icon: require('../assets/home_icon/contact_us.png'),
					name: '联系我们',
					english: 'Contact Us',
					key: 'contact_us',
					path: `/contact?backUrl=${encodeURIComponent(window.location.href)}`,
					is_web: false
				}
			]
		};
	},
	mounted() {
		// this.$localStorage.setItem('token', ''); //清除登录授权

		// 页面浏览 监测
		// this.$dataStatistics({
		// 	page_title: '首页'
		// });

		// this.$dataStatistics({ event_type: 'view', page_title: '首页' }, ``);

		// 环境变量获取方法
		console.log('process.env', process.env);

		this.initShare();
	},
	methods: {
		goNext(item, index) {
			if (!item.path) return;

			let data = {
				// path: item.path,
				page_title: item.name
			};
			this.$dataStatistics({ event_type: 'click', page_title: '首页导航' }, JSON.stringify(data));

			if (item.is_web) {
				location.href = item.path;
			} else {
				let length = this.$localStorage.getItem(`product_list_length`);

				for (let i = 0; i < length; i++) {
					this.$localStorage.setItem(`product_list_${i}`, false);
				}

				this.$localStorage.setItem(`p_list_scroll`, 0);
				this.$router.push({
					path: item.path,
					query: {}
				});
			}
		}
		// getDetails() {
		// 	this.$http
		// 		.get('/xxx/details', {
		// 			params: {
		// 				id: 'id'
		// 			}
		// 		})
		// 		.then((res) => {
		// 			console.log('res', res);
		// 		});
		// },
		// onClick() {
		// 	this.$router.push('/about');
		// },
		// onSubmit() {
		// 	const crypt = new Crypt(config.crypto.publickey);
		// 	const email = '1198810568@qq.com';
		// 	const phone = '15812040230';
		// 	this.$http
		// 		.post('/xxx/xxx', {
		// 			first_name: '测试',
		// 			last_name: '3号',
		// 			phone: crypt.aes_encrypt(phone),
		// 			email: crypt.aes_encrypt(email),
		// 			crypt_key: crypt.rsa_key_encrypt()
		// 		})
		// 		.then((res) => {
		// 			Toast('提交成功');
		// 		});
		// }
	}
};
</script>
<style lang="less" scoped>
.page {
	background-image: url('../assets/images/home_bg.png');
	background-position: top center;
	background-size: 828px 100%;
	background-repeat: no-repeat;

	.logo {
		position: absolute;
		top: 10.12vh;
		left: 145px;
		width: 277px;
		height: 175px;
		img {
			display: block;
			width: 100%;
			height: 100%;
		}
	}

	.tab {
		.inter {
			position: relative;
			overflow: hidden;
			padding-top: 12.8vh;
			padding-left: 36px;
			padding-bottom: 66px;
		}

		.item {
			width: 264px;
			height: 264px;
			float: right;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #fff;
			position: relative;
			box-shadow: 0 0 36px 0 rgba(51, 51, 51, 0.1);

			.flex {
				text-align: center;

				* {
					text-align: center;
				}

				.icon_box {
					margin-bottom: 25px;
					img {
						width: 69px;
						height: 69px;
						display: inline-block;
					}
				}

				.name {
					display: block;
					font-size: 33px;
					color: #e60027;
					line-height: 1;
					margin-bottom: 8px;
				}

				.emglish {
					display: block;
					font-size: 28px;
					color: #000000;
					line-height: 1;
				}
			}

			&.item_news {
				/* 企业动态 */
				z-index: 1;
			}
			&.item_resource {
				/* 资料中心 */
				z-index: 0;
				clear: right;
			}
			&.item_product {
				/* 产品中心 */
				z-index: 1;
				// width: calc(264px * 2);
				// .flex {
				// 	display: flex;
				// 	align-items: flex-end;
				// 	justify-content: flex-start;

				// 	& div {
				// 		text-align: left;
				// 	}

				// 	.icon_box {
				// 		margin-bottom: 0;
				// 		margin-right: 26px;
				// 	}
				// }
			}
			&.item_webinar {
				/* 微学院 */
				z-index: 3;
			}
			&.item_solution {
				//解决方案
				z-index: 2;
			}
			&.item_service {
				/* 售后服务 */
				z-index: 3;
				& * {
					// color: #fff !important;
				}
				// background-color: #e60027;
			}
			&.item_about_us {
				/* 关于我们 */
				z-index: 2;
			}
			&.item_contact_us {
				/* 联系我们 */
				z-index: 3;
			}
		}
	}
}
</style>
